import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContentCustom, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import type { BetterDocMissingField } from "@/modules/patients/detail/better-doc/types"

const MISSING_FIELD_TRANSLATION_KEYS: Record<BetterDocMissingField, string> = {
  specialty: "episodeOfCare.betterDoc.specialty",
  unsupportedSpecialty: "episodeOfCare.betterDoc.notSupportSpecialty",
  insurance: "episodeOfCare.betterDoc.missingInsureeNumber",
  phoneNumber: "episodeOfCare.betterDoc.phoneNumber",
  address: "episodeOfCare.betterDoc.address",
}

type BetterDocMissingFieldDialogProps = {
  open: boolean
  onClose: () => void
  missingFields: ReadonlyArray<BetterDocMissingField>
}

export const BetterDocMissingFieldDialog = ({ open, onClose, missingFields }: BetterDocMissingFieldDialogProps) => {
  const { t } = useTranslation()

  const handleCloseDialog = () => {
    onClose()
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContentCustom
        variant="small"
        onPointerDownOutside={(e) => e.preventDefault()}
        data-testid="better-doc-missing-field-dialog-content"
        className="max-w-md flex-col">
        <DialogHeader>
          <DialogTitle data-testid="better-doc-missing-field-dialog-title">
            {t("episodeOfCare.betterDoc.missingDialogTitle")}
          </DialogTitle>
        </DialogHeader>
        <div className="text-on-surface-subdued mx-6 my-4 flex flex-col text-sm">
          {t("episodeOfCare.betterDoc.missingDialogOpening")}
          {missingFields.length > 0 && (
            <ul className="ml-2 list-inside list-disc" data-testid="better-doc-missing-field-content">
              {missingFields.map((missingField) => (
                <li key={missingField}>{t(MISSING_FIELD_TRANSLATION_KEYS[missingField])}</li>
              ))}
            </ul>
          )}
        </div>
        <DialogFooter className="mt-auto flex p-6 pt-4" data-testid="better-doc-missing-field-dialog-footer">
          <Button className="px-4 py-2" variant="secondary" onClick={handleCloseDialog} data-testid="close-button">
            {t("common.button.close")}
          </Button>
        </DialogFooter>
      </DialogContentCustom>
    </Dialog>
  )
}
